import { useEffect, useRef, useState } from "react";

import { ClipboardList } from "@solar-icons/react/ssr";
import { Button, Grid } from "@mui/material";
import Divider from "@mui/material/Divider";
import { useDispatch } from "react-redux";
import { request } from "@/Api";
import { Plus } from "@/assets/svgs/Plus";
import { SectionTitle } from "@/common/typography";
import Milestone from "@/milestone/Milestone";
import MilestonePopup from "@/milestone/MilestonePopup";
import { setError } from "@/nav/navSlice";

export default function ProjectMilestones({
    projectId,
    milestones,
    setMilestones,
    readOnly,
    defaultMilestone,
}) {
    const dispatch = useDispatch();
    const [popupOpen, setPopupOpen] = useState(false);
    const [milestone, setMilestone] = useState({});
    const milestonesRef = useRef();

    const setPopupMilestone = (milestone) => {
        setMilestone(milestone);
        setPopupOpen(true);
    };

    const handleCopyLink = () => {
        request
            .get(`/calendar-url/${projectId}`)
            .then((response) => {
                const link = response.data;
                navigator.clipboard.writeText(link);
                dispatch(
                    setError({
                        message: `Copied link to clipboard`,
                        severity: "success",
                    }),
                );
            })
            .catch((error) => {
                dispatch(
                    setError({
                        message: `Failed to copy link: ${error.message}`,
                        severity: "error",
                    }),
                );
            });
    };

    useEffect(() => {
        if (defaultMilestone) {
            milestonesRef.current.scrollIntoView();
        }
    }, []);

    return (
        <div style={{ marginTop: 50 }} ref={milestonesRef}>
            <Divider sx={{ marginTop: 5, marginBottom: 5 }} />
            <Grid container justifyContent={"space-between"} paddingBottom={1}>
                <Grid item>
                    <SectionTitle bold>Milestones</SectionTitle>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        onClick={handleCopyLink}
                        startIcon={<ClipboardList size={18} />}
                        color="secondary"
                    >
                        Copy Calendar Link
                    </Button>
                </Grid>
            </Grid>

            {milestones.length > 0 ? (
                milestones.map((milestone, index) => (
                    <Milestone
                        key={index}
                        milestone={milestone}
                        milestones={milestones}
                        setMilestones={setMilestones}
                        setPopupMilestone={setPopupMilestone}
                        readOnly={readOnly}
                    />
                ))
            ) : (
                <p>None</p>
            )}

            {readOnly ? null : (
                <Button
                    variant="contained"
                    label="Add Milestone"
                    onClick={() => {
                        setPopupOpen(true);
                    }}
                    color="secondary"
                    endIcon={<Plus />}
                >
                    Add
                </Button>
            )}

            <MilestonePopup
                milestone={milestone}
                setMilestone={setMilestone}
                milestones={milestones}
                setMilestones={setMilestones}
                projectId={projectId}
                popupOpen={popupOpen}
                setPopupOpen={setPopupOpen}
            />
        </div>
    );
}
